import { useEffect, useState } from "react";
import { Button, Modal, Form } from "react-bootstrap";
import { apiService } from '../functions/api-service';
import { Alert, HandleChange, OptionSelects } from '../functions/utils';
import {ChangeEvent, Department, User,} from '../type';

type Props = {
  show: boolean;
  data: User | null;
  handleClose: () => void;
  saved: () => void;
  setUserId: (userId: number) => void
};

export default function ModalUser ( { show, data, handleClose, saved }: Props ) {
  let IsNew = true;
  const [dataForm, setDataForm] = useState<User | null>( null );
  const handleChange = (e: ChangeEvent) => HandleChange(setDataForm, e);

  const handleSave = async () => {
    console.log( 'dataForm_>', dataForm )
    if(dataForm){
      // if(!IsNew){
      //   delete (dataForm.password)
      // }
      const res = await apiService.saveUser( dataForm );
      if ( res.success === true ) {
        saved();
        handleClose();
      }
      Alert(res.success, res.message);
    }    
  }

  useEffect(() => {
    if ( show ) {
      setDataForm( data );
      console.log( 'data', data );
      IsNew = !data?.userID;
    } else {
      setDataForm( null );
    }
  }, [show]);
  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        // size={"lg"}
      >
        <Modal.Header closeButton>
          <Modal.Title>{IsNew ? `เพิ่มรายการ` : `แก้ไข ${dataForm?.firstName} ${dataForm?.lastName}`}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form className={"row row-cols"} onSubmit={( e ) => {
            e.preventDefault();
            handleSave().then();
          }}>
            <Form.Group className="mb-3" controlId="name">
              <Form.Label>Username</Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="Username"
                onChange={handleChange}
                name={"username"}
                value={dataForm?.username}
              />
            </Form.Group>

            {!data?.userID && <Form.Group className="mb-3" controlId="password">
              <Form.Label>Password</Form.Label>{IsNew}
              <Form.Control
                  required
                  type="password"
                  placeholder="Password"
                  onChange={handleChange}
                  name={"password"}
              />
            </Form.Group>
            }

            <Form.Group className="mb-3" controlId="firstName">
              <Form.Label>ชื่อ</Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="ระบุชื่อ"
                onChange={handleChange}
                name={"firstName"}
                value={dataForm?.firstName}
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="name">
              <Form.Label>นามสกุล</Form.Label>
              <Form.Control
                  required
                  type="text"
                  placeholder="ระบุชื่อนามสกุล"
                  onChange={handleChange}
                  name={"lastName"}
                  value={dataForm?.lastName}
              />
            </Form.Group>


            <Form.Group className="mb-3" controlId="site">
              <Form.Label>Site</Form.Label>
              <Form.Control
                  required
                  type="text"
                  placeholder="ระบุ site"
                  onChange={handleChange}
                  name={"site"}
                  value={dataForm?.site}
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="sub">
              <Form.Label>Sub site</Form.Label>
              <Form.Control
                  required
                  type="text"
                  placeholder="ระบุ sub site"
                  onChange={handleChange}
                  name={"sub"}
                  value={dataForm?.sub}
              />
            </Form.Group>
            
            <div className="w-100 text-end">
              <Button variant="secondary" size="lg" onClick={handleClose}>
                ปิด
              </Button>{" "}
              <Button variant="primary" type="submit" size="lg">
                บันทึก
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>    
    </>
  );
}
